import type { FeedEntry } from '~/services/layout';

export function getIndicatorShowProp(
  indicators_switch: boolean,
  isLoading: boolean | undefined,
  indicatorsEntries: FeedEntry[]
): boolean {
  return (
    indicators_switch &&
    !isLoading &&
    Array.isArray(indicatorsEntries) &&
    Number(indicatorsEntries?.length) > 0
  );
}

export function getIndicatorProps({
  indicatorsEntries,
  styles,
  isLoading,
}: any) {
  const {
    indicators_switch,
    indicator_arrows_switch,
    indicators_position,
    indicator_arrow_left_asset_default,
    indicator_arrow_right_asset_default,
  } = styles;

  return {
    show: getIndicatorShowProp(indicators_switch, isLoading, indicatorsEntries),
    entries: indicatorsEntries as FeedEntry[],
    position: indicators_position,
    arrowsSwitch: indicator_arrows_switch,
    arrowLeftAsset: indicator_arrow_left_asset_default,
    arrowRightAsset: indicator_arrow_right_asset_default,
  };
}

/**
 * Checks if the horizontal list container is at least 50% visible in the viewport.
 * @returns true if at least 50% of the element is visible vertically, false otherwise.
 */
export function isContainerFullyVisible(target: HTMLElement | null): boolean {
  if (!target) return false;

  const rect = target.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate visible height
  const visibleTop = Math.max(rect.top, 0);
  const visibleBottom = Math.min(rect.bottom, viewportHeight);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);

  return rect.height > 0 && visibleHeight / rect.height >= 0.5;
}
